'use client';

import { useContext, useEffect } from 'react';
import { AppStoreContext, useStore } from '@/providers/app-store-provider';
import { env } from '@/utils/env';

/** 登录数据已确认后后台合并，覆盖恢复登录；不依赖配镜 iframe 生命周期。 */
export function useLensGuestPrescriptions() {
  const store = useContext(AppStoreContext);
  const token = useStore((state) => state.token);
  const accountId = useStore((state) =>
    state.userInfoReady && state.userInfo?.id ? String(state.userInfo.id) : null,
  );
  useEffect(() => {
    if (!store || !token || !accountId) return;
    const controller = new AbortController();
    void import('@/domain/lens/guest-prescription-merge')
      .then(({ syncLensGuestPrescriptions }) =>
        syncLensGuestPrescriptions(
          `zeelool-${env.NEXT_PUBLIC_SITE_NAME}`,
          () =>
            store.getState().token === token && String(store.getState().userInfo?.id) === accountId
              ? accountId
              : null,
          controller.signal,
        ),
      )
      .catch(() => {});
    return () => controller.abort();
  }, [store, token, accountId]);
}
